export const EVENT_TYPE_ADD = 'EVENT_TYPE_ADD';
export const EVENT_TYPE_AREAS = 'EVENT_TYPE_AREAS';
export const EVENT_TYPE_SELECTED_AREA = 'EVENT_TYPE_SELECTED_AREA';
